<template>
    <div class="manage-box">
        <machine-header></machine-header>
        <machine-sidebar></machine-sidebar>
        <div class="wrapper-box" v-loading="loading" :class="{'content-collapse':collapse}">
            <!-- <v-breadcrumb></v-breadcrumb> -->
            <tag-view></tag-view>
            <transition name="component-fade" mode="out-in">
                <router-view :key="key" v-if="isRouterAlive"></router-view>
            </transition>
        </div>

        <!-- 设备报警 -->
        <el-dialog title="设备信息" :visible.sync="dialogTableVisible">
            <el-row :gutter="20">
                <el-col :span="12"><div style="line-height:30px;">序列号：{{terminalData.TerminalSerial}}</div></el-col>
                <el-col :span="12"><div style="line-height:30px;">设备型号：{{terminalData.DevModule}}</div></el-col>
                <el-col :span="12"><div style="line-height:30px;">设备名称：{{terminalData.customized_serial}}</div></el-col>
                <el-col :span="12"><div style="line-height:30px;">所属集控器：{{terminalData.CollectorName}}</div></el-col>
                <el-col :span="12"><div style="line-height:30px;">集控器序列号：{{terminalData.CollectorSerial}}</div></el-col>
                <!-- <el-col :span="12"><div style="line-height:30px;">安装位置：{{terminalData.HouseHoldName}}</div></el-col> -->
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"; 
import MachineHeader from "@/components/header/MachineHeader";
import MachineSidebar from "@/components/header/MachineSidebar";
// import vBreadcrumb from "@/components/header/breadcrumb";
import TheFooter from "@/components/TheFooter";
import tagView from "@/components/tagView/tagView";
import bus from "@/utils/bus";
import { FormatDate, Guid } from '@/utils/utils'
export default {
    name: "MachineLayOut",
    provide() {
        return {
            reload: this.reload,
        };
    },
    data() {
        return {
            isRouterAlive: true,
            collapse: false,
            loading: false,

            dialogTableVisible: false,
            terminalData: {},
        };
    },
    components: {
        MachineHeader,
        TheFooter,
        MachineSidebar,
        // vBreadcrumb,
        tagView
    },
    computed: {
        ...mapGetters(["WS", "ws_notice","projectInfo","user"]),
        key() {
            return this.$route.fullPath;
        },
        noticeTerminal() {
            let notice = this.ws_notice || []
            return notice.map(v=>{
                let { status,title } = v
                return Object.assign({}, v.terminal, { status,title });
            })
        }
    },
    watch: {
        // 监听socket数据
        ws_notice: {
            handler(newVal,oldVal){
                //code...业务逻辑
                this.Notice_Project(newVal)
            },
            immidiate:true,
            deep:true,
        }
    },
    mounted() {
        this.$store.dispatch("socketLogin").then(() => {
            this.WS.onopen(() => {
                let userid = this.user.oid + '';
                // 获取项目OID
                this.$store.dispatch("GetProjectSystemInfo").then(res => {
                    let assigned_project_id = res.oid + '';
                    let gid = Guid();
                    this.WS.send(JSON.stringify({userid, assigned_project_id: assigned_project_id, sendtype: "10", gid: gid}))
                })
				this.$store.dispatch("GetProjectInfo")
            })
            this.WS.onclose(()=>{
                // console.log('websocket连接失败: onclose');
            })
            this.WS.onerror(() => {
                // console.log('websocket连接失败: onerror');
            });
        });
    },
    destroyed() {
        //  console.log("机房系统销毁")
    },
    created() {
        bus.$on("collapse", msg => {
            this.collapse = msg;
        });
        // 数据请求加载动画
        bus.$on('showloading', msg => {
            this.loading = msg
        })
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function() {
                this.isRouterAlive = true;
            });
        },
        // 报警通知
        Notice_Project(data) {
			console.log(data)
            const h = this.$createElement;
            let list = data;
            list.map(v=>{
                let icon, title, duration, message;
                // message = FormatDate("yyyy-MM-dd HH:mm:ss") + `  设备序列号：${v.terminal.TerminalSerial}`;
				message = FormatDate("yyyy-MM-dd HH:mm:ss");
                if(v.status === 1) {
                    icon = 'warning';
                    title = v.title;
                    duration = 10000;
                }
                if(v.status === 2) {
                    icon = 'success';
                    title = v.title;
                    duration = 5000;
                }
                
                setTimeout(() => {
                    let Notify = this.$notify({
                        type: icon,
                        title: title,
                        duration: duration,
                        message: h('div', {
                                attrs: {
                                    class: "notice-box"
                                },
                            }, [
                                h('p', {
                                    attrs: {
                                        class: "notice-title"
                                    }
                                }, message),
                                h('span', {
                                    on: {
                                        click: this.handleClickDetail
                                    },
                                    attrs: {
                                        class: "notice-btn",
                                        // ['data-id']: v.terminal.OID,
										['data-id']: v.id,
                                    }
                                }, "查看详情"),
                        ]),
                        position: 'bottom-right',
                    });
                }, 1000);
            })
        },
        handleClickDetail(e) {
            let id = e.currentTarget.getAttribute('data-id');
            let terminal = this.noticeTerminal.filter(v=>{return id == v.OID});
            this.terminalData = terminal[0];
            this.dialogTableVisible = true;
        },
    }
};
</script>

<style scoped>
.manage-box {
    min-height: 100vh;
    /* display: flex;
    flex-direction: column;
    flex: auto; */
    text-align: left;
}
.wrapper-box {
    position: absolute;
    left: 250px;
    right: 0;
    top: 60px;
    bottom: 0;
    /* padding-bottom: 30px; */
    transition: left 0.3s ease-in-out;
    background: #f8f8f8;
    overflow-y: auto;
}
.wrapper-box.content-collapse {
    left: 65px;
}
.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
    font-weight: 500;
    color: #606266;
}
.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity 0.3s ease;
}
.component-fade-enter,
.component-fade-leave-to {
    opacity: 0;
}
</style>
